import { WayPoint } from '@bringg/types';
import moment from 'moment';

export const areAllDatesInTheSameDay = dates => {
	for (let i = 0; i < dates.length - 1; i += 1) {
		if (!dates[i].isSame(dates[i + 1], 'day')) {
			return false;
		}
	}
	return true;
};

const getDropOffWayPointsDates = (dropOffWayPoints, propertyName, secondaryPropertyName) => {
	return dropOffWayPoints.map(wayPoint =>
		wayPoint[propertyName] ? moment(wayPoint[propertyName]) : moment(wayPoint[secondaryPropertyName])
	);
};

export const areTasksInSameDay = (
	tasksDropOffWayPoints: WayPoint[],
	propertyName: string,
	secondaryPropertyName: string
) => {
	const dates = getDropOffWayPointsDates(tasksDropOffWayPoints, propertyName, secondaryPropertyName);
	return areAllDatesInTheSameDay(dates);
};
